import { kusty } from 'globals/assets';

const styles = {
  default: {
    backgroundSize: '50px',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url("${kusty}")`,
    height: 50,
    width: 50,
  },
};

export default styles;
